import { render, staticRenderFns } from "./GoodsDialog.vue?vue&type=template&id=e4132b0c&scoped=true&"
import script from "./GoodsDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDialog.vue?vue&type=style&index=0&id=e4132b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4132b0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4132b0c')) {
      api.createRecord('e4132b0c', component.options)
    } else {
      api.reload('e4132b0c', component.options)
    }
    module.hot.accept("./GoodsDialog.vue?vue&type=template&id=e4132b0c&scoped=true&", function () {
      api.rerender('e4132b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fullDiscount/components/GoodsDialog.vue"
export default component.exports